import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { persistTokenizedSession, tokenize } from "../../actions/auth";
import { useNavigate } from "react-router-dom";
import { buildSurveyTokenizeUrl } from "../../utils/survey-link";

export const Tokenize = ({ tokenize }) => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        const persistData = async () => {
            const params = new URLSearchParams(window.location.search);
            const token = params.get("t");
            const instance = params.get("i");
            const secure = params.get("s") === "1";
            const address = params.get("a");
            const port = params.get("p");
            const next = params.get("next");
            const url = address ? `http${secure ? "s" : ""}://${address}${port ? `:${port}` : ""}/` : null;

            if (!token || !instance) {
                setError("This sign-in link is incomplete. Please reopen your survey and sign in again.");
                return;
            }

            const surveyHandoff = buildSurveyTokenizeUrl({ url: next, instance }, { token });
            if (surveyHandoff) {
                persistTokenizedSession(instance, token, url);
                // Survey verifies the incoming session. Loading the unrelated
                // client portal first can fail and strand a saved-survey login.
                window.location.replace(surveyHandoff);
                return;
            }

            if (!address) {
                setError("This sign-in link is incomplete. Please sign in again.");
                return;
            }
            try {
                if (await tokenize(instance, token, url)) {
                    navigate("/dashboard", { replace: true });
                } else {
                    setError("Sign-in could not be completed. Please return to your survey and sign in again.");
                }
            } catch (err) {
                setError("Sign-in could not be completed. Please sign in again.");
            }
        };

        persistData();
    }, [tokenize, navigate]);

    return (
        <main aria-live="polite" className="d-flex min-vh-100 align-items-center justify-content-center">
            <p role={error ? "alert" : undefined}>{error || "Completing sign-in\u2026"}</p>
        </main>
    );
};

export default connect(null, { tokenize })(Tokenize);
